var _mask, _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgress8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_381_487",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C11.8359 2.18929e-08 13.6364 0.505403 15.2041 1.46082C16.7718 2.41623 18.0462 3.78478 18.8877 5.41647C19.7292 7.04817 20.1053 8.88002 19.9747 10.7113C19.8441 12.5425 19.2119 14.3025 18.1474 15.7983C17.0829 17.294 15.6272 18.4679 13.9398 19.1912C12.2524 19.9145 10.3984 20.1593 8.58107 19.8988C6.76374 19.6383 5.05321 18.8826 3.63693 17.7144C2.22065 16.5462 1.1533 15.0106 0.55185 13.276L10 10L10 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C11.8359 2.18929e-08 13.6364 0.505403 15.2041 1.46082C16.7718 2.41623 18.0462 3.78478 18.8877 5.41647C19.7292 7.04817 20.1053 8.88002 19.9747 10.7113C19.8441 12.5425 19.2119 14.3025 18.1474 15.7983C17.0829 17.294 15.6272 18.4679 13.9398 19.1912C12.2524 19.9145 10.3984 20.1593 8.58107 19.8988C6.76374 19.6383 5.05321 18.8826 3.63693 17.7144C2.22065 16.5462 1.1533 15.0106 0.55185 13.276L10 10L10 0Z",
    fill: "#09702B",
    stroke: "#09702B",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_381_487)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    transform: "rotate(-90 10 10)",
    stroke: "#09702B",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress8);
export default __webpack_public_path__ + "static/media/progress8.f012d34fb425b3a7093c5aa7cdf83b26.svg";
export { ForwardRef as ReactComponent };